import { ThumbsUp, ThumbsDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ESCALATION_CATEGORY_INFO } from "@/lib/categoryInfo";
import { SCENARIOS } from "@/constants/testIds";

export default function ScenarioCard({ scenario, onVote }) {
  const catInfo = ESCALATION_CATEGORY_INFO[scenario.category] || { label: scenario.category, color: "text-zinc-600 border-zinc-300", votable: true };
  const total = scenario.votes_bias + scenario.votes_not_bias;
  const biasPct = total > 0 ? Math.round((scenario.votes_bias / total) * 100) : 0;
  const isVotable = catInfo.votable !== false;

  return (
    <div
      data-testid={SCENARIOS.card(scenario.id)}
      className="bg-white border border-zinc-200 rounded-sm p-6 hover:border-zinc-400 hover:shadow-md transition-all duration-200"
    >
      <div className="flex items-center justify-between mb-3">
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase border ${catInfo.color}`}>
          {catInfo.label}
        </span>
        <span className="text-xs text-zinc-400">{new Date(scenario.created_at).toLocaleDateString()}</span>
      </div>

      <h3 data-testid={SCENARIOS.cardTitle(scenario.id)} className="font-display font-bold text-lg text-zinc-950 mb-2">
        {scenario.title}
      </h3>
      <p className="text-zinc-600 text-sm leading-relaxed mb-5">{scenario.content}</p>

      <div className="mb-4">
        <div className="flex justify-between text-xs text-zinc-500 mb-1">
          <span>{scenario.votes_bias} said this is bias</span>
          <span>{scenario.votes_not_bias} said it isn't</span>
        </div>
        <div className="h-1.5 w-full bg-zinc-100 rounded-full overflow-hidden">
          <div className="h-full bg-[#1E3A6E] transition-all" style={{ width: `${biasPct}%` }} />
        </div>
      </div>

      <div className="flex gap-3">
        {isVotable ? (
          <>
            <Button
              onClick={() => onVote(scenario.id, "bias")}
              data-testid={SCENARIOS.voteBiasButton(scenario.id)}
              variant={scenario.user_vote === "bias" ? "default" : "outline"}
              className={scenario.user_vote === "bias"
                ? "flex-1 bg-[#1E3A6E] text-white font-medium rounded-none hover:bg-zinc-950"
                : "flex-1 border-zinc-300 text-zinc-800 rounded-none hover:border-zinc-950"}
            >
              <ThumbsUp className="h-4 w-4 mr-2" /> This is bias
            </Button>
            <Button
              onClick={() => onVote(scenario.id, "not_bias")}
              data-testid={SCENARIOS.voteNotBiasButton(scenario.id)}
              variant={scenario.user_vote === "not_bias" ? "default" : "outline"}
              className={scenario.user_vote === "not_bias"
                ? "flex-1 bg-zinc-800 text-white font-medium rounded-none"
                : "flex-1 border-zinc-300 text-zinc-500 rounded-none hover:border-zinc-950"}
            >
              <ThumbsDown className="h-4 w-4 mr-2" /> Not bias
            </Button>
          </>
        ) : (
          <div className="flex-1 text-center py-2 text-xs font-bold uppercase tracking-wide text-red-700 bg-red-50 border border-red-200 rounded-sm">
            Safety emergency — routed to BERN, not a vote
          </div>
        )}
      </div>
    </div>
  );
}
